async function handleResponse(response) {
    if (response.ok) {
        return response.json();
    }
    if (response.status === 400) {
        const error = await response.text();
        throw new Error(error);
    } else if (response.status === 404) {
        console.log("API call failed. 404 Not Found.")
        // Template data may not have been saved in Module setting yet.
        return null;
    }
    throw new Error("Network response was not ok.");
}

function handleError(error) {
    console.error("API call failed. " + error);
    throw error;
}

export function getData(url, responseHandler = handleResponse, errorHandler = handleError) {
    return fetch(url, {
        headers: {
            ...setAppRequestHeaders(parseInt(document.getElementById('hdnStencilDisplaySettingsModuleId').value))
        }
    })
        .then(responseHandler)
        .catch(errorHandler);
}

export function postData(url, data) {
    return fetch(url, {
        method: 'POST',
        headers: {
            ...setAppRequestHeaders(parseInt(document.getElementById('hdnStencilDisplaySettingsModuleId').value)),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)

    })
        .then(handleResponse)
        .catch(handleError);
}

function setAppRequestHeaders(moduleId) {
    if ($.ServicesFramework) {
        // Set up services framework.
        var sf = $.ServicesFramework(moduleId)
        var headers = {
            ModuleId: sf.getModuleId(),
            TabId: sf.getTabId()
        };

        // Set the anti-forgery token header.
        var antiForgeryKey = sf.getAntiForgeryKey()
        var antiForgeryValue = sf.getAntiForgeryValue()
        headers[antiForgeryKey] = antiForgeryValue

        // Fallback in case getAntiForgeryKey() does not return the correct key.
        if (antiForgeryKey !== 'RequestVerificationToken') {
            headers["RequestVerificationToken"] = antiForgeryValue
        }

        return headers
    }
    else {
        // Return null if Service Framework not found
        return null
    }
}
